export const DOC_LABEL: Record<string, string> = {
  order_response: 'OrderResponse',
  despatch_advice: 'DespatchAdvice',
  invoice: 'Invoice',
}

export const DOC_COLORS: Record<string, string> = {
  order_response: 'bg-blue-50 text-blue-700 border-blue-200',
  despatch_advice: 'bg-purple-50 text-purple-700 border-purple-200',
  invoice: 'bg-green-50 text-green-700 border-green-200',
}
